function renderBuildResultMappingResultTemplate({
  plural,
  rowDeclarations,
  rowMappings
}: {
  plural: string
  rowDeclarations: string
  rowMappings: string
}): string {
  return `

    const mapped${plural} = results.map((rawRow) => {
      const row = rawRow as Record<string, unknown>
${rowDeclarations}

      return {
${rowMappings}
      }
    })`
}

function renderBuildResultMappingResultDetailsTemplate({
  mapBlock,
  plural,
  singular,
  camelPlural
}: {
  mapBlock: string
  plural: string
  singular: string
  camelPlural: string
}): string {
  return `${mapBlock}

    const populated${plural} = await Promise.all(
      mapped${plural}.map(record => populate${singular}ListRelationships(record as ${singular}))
    )

    return {
      ${camelPlural}: populated${plural},
      total
    }`
}

function renderBuildResultMappingResultDetailsBranchTemplate({
  mapBlock,
  camelPlural,
  plural,
  singular
}: {
  mapBlock: string
  camelPlural: string
  plural: string
  singular: string
}): string {
  return `${mapBlock}

    return {
      ${camelPlural}: mapped${plural} as unknown as ${singular}[],
      total
    }`
}

export function renderBuildResultMappingRenderer(
  request:
    | {
        kind: 'renderBuildResultMappingResultTemplate'
        props: {
          plural: string
          rowDeclarations: string
          rowMappings: string
        }
      }
    | {
        kind: 'renderBuildResultMappingResultDetailsTemplate'
        props: {
          mapBlock: string
          plural: string
          singular: string
          camelPlural: string
        }
      }
    | {
        kind: 'renderBuildResultMappingResultDetailsBranchTemplate'
        props: {
          mapBlock: string
          camelPlural: string
          plural: string
          singular: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderBuildResultMappingResultTemplate':
      return renderBuildResultMappingResultTemplate(request.props)
    case 'renderBuildResultMappingResultDetailsTemplate':
      return renderBuildResultMappingResultDetailsTemplate(request.props)
    case 'renderBuildResultMappingResultDetailsBranchTemplate':
      return renderBuildResultMappingResultDetailsBranchTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
